// RejectSubmissionModal.jsx - Modal for rejecting submissions with feedback
import React from 'react';

function RejectSubmissionModal({ 
  submissionId, 
  onClose, 
  rejectionNotes, 
  setRejectionNotes, 
  onReject 
}) {
  if (!submissionId) return null;

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 999
        }}
      />
      
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'white',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        zIndex: 1000,
        minWidth: '500px'
      }}>
        <h3 style={{ margin: '0 0 16px 0', color: '#2c3e50' }}>
          Reject Marking
        </h3>
        <p style={{ color: '#7f8c8d', marginBottom: '16px' }}>
          Provide feedback for the marker explaining what needs to be corrected:
        </p>
        
        <textarea
          value={rejectionNotes}
          onChange={(e) => setRejectionNotes(e.target.value)}
          placeholder="Enter feedback for the marker..."
          style={{
            width: '100%',
            minHeight: '120px',
            padding: '12px',
            border: '2px solid #ecf0f1',
            borderRadius: '8px',
            fontSize: '14px',
            fontFamily: 'inherit',
            marginBottom: '16px',
            resize: 'vertical'
          }}
        />
        
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '12px 24px',
              background: '#ecf0f1',
              color: '#2c3e50',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Cancel
          </button>
          
          <button
            onClick={() => onReject(submissionId)}
            style={{
              padding: '12px 24px',
              background: '#e74c3c',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Reject & Send Back
          </button>
        </div>
      </div>
    </>
  );
}

export default RejectSubmissionModal;